import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VideoFinal.css';

// ==== Carga dinámica del fondo del juego ====
const imgGenerales = {};

function keyFrom(name) {
  return String(name || '')
    .replace(/\.(png|jpe?g|svg|webp)$/i, '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s-]+/g, '_');
}

function importAll(ctx, target) {
  ctx.keys().forEach((key) => {
    const clean = key.replace('./', '');
    target[keyFrom(clean)] = ctx(key);
  });
}

importAll(
  require.context('../assets/img_generales', false, /\.(png|jpe?g|svg|webp)$/),
  imgGenerales
);

const fondo = imgGenerales['fondo'];

const VideoFinal = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);

  const [autorizado, setAutorizado] = useState(false);
  const [mostrarVideo, setMostrarVideo] = useState(false);
  const [videoTerminado, setVideoTerminado] = useState(false);
  const [errorVideo, setErrorVideo] = useState(false);

  const usuario = localStorage.getItem('usuario') || 'Jugador';

  // Evita acceder al video escribiendo directamente /video-final


  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const modoPrueba = params.get('test') === '1';

  const habilitado =
    sessionStorage.getItem('videoFinalHabilitado') === 'true';

  if (!habilitado && !modoPrueba) {
    navigate('/seleccionar-nivel', { replace: true });
    return;
  }

  setAutorizado(true);
}, [navigate]);
  // Reproducir después de presionar el botón
  useEffect(() => {
    if (mostrarVideo && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log('El navegador requiere iniciar el video manualmente:', error);
      });
    }
  }, [mostrarVideo]);

  const iniciarVideo = () => {
    setMostrarVideo(true);
  };

  const finalizarTurno = () => {
    sessionStorage.removeItem('videoFinalHabilitado');
    navigate('/seleccionar-nivel', { replace: true });
  };

  if (!autorizado) {
    return null;
  }

  return (
    <div
      className="video-final-container"
      style={{ backgroundImage: `url(${fondo})` }}
    >
      <div className="video-final-card">

        {/* ============================= */}
        {/* PANTALLA PREVIA AL VIDEO */}
        {/* ============================= */}

        {!mostrarVideo && (
          <div className="video-final-intro">
            <h1>BUEN TRABAJO <strong>{usuario}</strong></h1>

            <p className="video-final-texto">
              Has trabajado muy bien durante el turno.
            </p>

            <p className="video-final-destacado">
              ¡Felicitaciones!
            </p>

            <button
              className="btn-video-final"
              onClick={iniciarVideo}
            >
              ▶ MENSAJE FINAL
            </button>
          </div>
        )}

        {/* ============================= */}
        {/* VIDEO */}
        {/* ============================= */}

        {mostrarVideo && !videoTerminado && !errorVideo && (
          <div className="video-final-reproductor">
            <video
              ref={videoRef}
              className="video-final-video"
              controls
              playsInline
              onEnded={() => setVideoTerminado(true)}
              onError={() => setErrorVideo(true)}
            >
              <source
                src="/videos/VideoFinal.mp4"
                type="video/mp4"
              />

              Tu navegador no permite reproducir este video.
            </video>
          </div>
        )}

        {/* ============================= */}
        {/* FELICITACIÓN FINAL */}
        {/* ============================= */}

        {videoTerminado && (
          <div className="video-final-cierre">
            <div className="video-final-icono">
              🏆
            </div>

            <h1>¡LO LOGRAMOS!</h1>

            <p className="video-final-texto">
              Felicitaciones <strong>{usuario}</strong>.
            </p>

            <p className="video-final-destacado">
              Has superado todos los niveles de Turno24RX
            </p>

            <button
              className="btn-video-final"
              onClick={finalizarTurno}
            >
              ✅ FINALIZAR TURNO
            </button>
          </div>
        )}

        {/* ============================= */}
        {/* ERROR DE VIDEO */}
        {/* ============================= */}

        {errorVideo && (
          <div className="video-final-cierre">
            <h2>⚠️ No fue posible reproducir el mensaje final</h2>

            <p className="video-final-texto">
              Pero tu turno está completo, <strong>{usuario}</strong>.
            </p>

            <p className="video-final-destacado">
              ¡Felicitaciones por completar Turno24RX!
            </p>

            <button
              className="btn-video-final"
              onClick={finalizarTurno}
            >
              ✅ FINALIZAR TURNO
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default VideoFinal;
